<template lang="pug">
.tab-container
  .tab-block
    .tab-left(v-if="chooseTab" @click="changeTab(true)" :class="isRenewSendCoupon?'tab_no_bg':''")
      .tab-left-title
        span.small-font 连续包月¥
        span.big-font {{signInfoDTO.firstSignPrice>=0?signInfoDTO.firstSignPrice:'-'}}
      .tab-left-price 日常价¥{{markedPrice||'-'}}
      .tab-rotate-transform(v-if="!isRenewSendCoupon")
        .tab-rotate-font 立省{{getValue(markedPrice-signInfoDTO.firstSignPrice)||'-'}}元
      .tab-left-word(v-else-if="info.couponMaps.circle")
        span 首月限时减{{info.couponMaps.circle.couponPromoAmount}}元
      .continuous-corner-mark(:style="getCornerMarkStyle") {{continuousCornerMark || '限时'}}
    .tab-left-gary(
      v-else
      @click="changeTab(false)"
      :style="unChooseImg"
      :class="isRenewSendCoupon?'tab_no_bg_white':''")
      .tab-left-title
        span.small-font 连续包月¥
        span.big-font {{signInfoDTO.firstSignPrice>=0?signInfoDTO.firstSignPrice:'-'}}
      .tab-left-price 日常价¥{{markedPrice||'-'}}
      .tab-rotate-transform(v-if="!isRenewSendCoupon")
        .tab-rotate-font 立省{{getValue(markedPrice-signInfoDTO.firstSignPrice)||'-'}}元
      .tab-left-word(v-else-if="info.couponMaps.circle")
        span 首月限时减{{info.couponMaps.circle.couponPromoAmount}}元
      .continuous-corner-mark(:style="getCornerMarkStyle") {{continuousCornerMark || '限时'}}
    .tab-right(
      v-if="chooseTab"
      @click="changeRightTab(true)"
      :style="unChoosecolor" )
      .tab-right-title
        span.small-font 开通一个月¥
        span.big-font {{price>=0?price:'-'}}
      .tab-right-price 日常价¥{{markedPrice||'-'}}
    .tab-right-gary(
        v-else
        @click="changeRightTab(false)")
      .tab-right-title
        span.small-font 开通一个月¥
        span.big-font {{price>=0?price:'-'}}
      .tab-right-price 日常价¥{{markedPrice||'-'}}
</template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  props: {
    markedPrice: {
      type: Number,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    signInfoDTO: {
      type: Object,
      default: () => { },
    },
    // 页面是未开通页还是已开通页
    openType: {
      type: String,
      required: true,
    },
    isRenewSendCoupon: {
      type: Boolean,
      default: true,
    },
    info: {
      type: Object,
      default: () => { },
    },
    continuousCornerMark: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chooseTab: true,
    };
  },
  computed: {
    unChooseImg() {
      if (this.openType === 'toOpen') {
        return {
          backgroundImage: 'url(https://m.hellobike.com/d03e938a_829221.png)',
        };
      }
      if (this.isRenewSendCoupon) {
        return {
          backgroundImage: 'none',
        };
      }
      return {
        backgroundImage: 'url(https://m.hellobike.com/d03e938a_829221.png)',
      };
    },
    unChoosecolor() {
      if (this.openType === 'toOpen') {
        return {
          background: '#F7F9FA',
        };
      }
      return {
        background: '#fff',
      };
    },
    getCornerMarkStyle() {
      const position = this.continuousCornerMark ? {
        left: '-0.02rem',
        top: '-0.05rem',
      } : {};
      return position;
    },
  },
  methods: {
    changeTab(val) {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_type_choose_detail',
        categoryId: 'platform',
        businessInfo: {
          type: 1,
        },
      });
      if (!val) {
        this.chooseTab = true;
        this.$emit('chooseMember', true);
      }
    },
    changeRightTab(val) {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_type_choose_detail',
        categoryId: 'platform',
        businessInfo: {
          type: 2,
        },
      });
      if (val) {
        this.chooseTab = false;
        this.$emit('chooseMember', false);
      }
    },
    getValue(val) {
      return parseFloat((val).toFixed(2));
    },
  },
};

</script>
<style lang="less" scoped>
.tab-container {
  .tab-block {
    display: flex;
    justify-content: space-between;

    .continuous-corner-mark {
      position: absolute;
      left: 0;
      top: 0;
      height: 0.16rem;
      border-radius: 0.08rem 0;
      background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
      color: #fff;
      font-family: "PingFang SC", sans-serif;
      font-size: 0.1rem;
      font-weight: 500;
      padding: 0 0.07rem 0 0.05rem;
    }

    .tab-left {
      width: 1.64rem;
      height: 0.6rem;
      background: linear-gradient(180deg, #fff9ef 0%, #fff8e9 100%);
      border-radius: 0.08rem;
      padding: 0.1rem 0 0 0.12rem;
      background-image: url(https://m.hellobike.com/80db862a_829823923.png);
      background-size: 100% 100%;
      position: relative;

      .tab-left-title {
        .small-font {
          font-size: 0.12rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #fa2a00;
        }

        .big-font {
          font-size: 0.24rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #fa2a00;
        }
      }

      .tab-left-price {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #879099;
      }

      .tab-rotate-transform {
        position: absolute;
        font-size: 0.12rem;
        font-family: DINAlternate-Bold, DINAlternate, sans-serif;
        font-weight: bold;
        color: #d33535;
        top: 0.05rem;
        right: -0.1rem;
        transform: scale(0.7);

        .tab-rotate-font {
          opacity: 0.5;
          transform: rotate(31deg);
        }
      }

      .tab-left-word {
        width: 0.87rem;
        height: 0.14rem;
        border-radius: 0.08rem 0 0.08rem 0;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
        color: #fff;
        font-family: PingFang SC;
        font-size: 0.1rem;
        font-weight: 500;
        line-height: 0.14rem;
        text-align: center;
      }
    }

    .tab_no_bg {
      background-image: none;
      border: 1.5px solid #ffd779;
      background: linear-gradient(134.43deg, rgba(255, 255, 255, 0.898137) 5.2%, rgba(255, 249, 237, 0.761582) 96.53%);
    }

    .tab-left-gary {
      width: 1.64rem;
      height: 0.6rem;
      background: linear-gradient(180deg, #fff9ef 0%, #fff8e9 100%);
      border-radius: 0.08rem;
      padding: 0.1rem 0 0 0.12rem;
      background-image: url(https://m.hellobike.com/80db862a_829823923.png);
      background-size: 100% 100%;
      position: relative;

      .tab-left-title {
        .small-font {
          font-size: 0.12rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #242729;
        }

        .big-font {
          font-size: 0.24rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #242729;
        }
      }

      .tab-left-price {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #879099;
      }

      .tab-rotate-transform {
        position: absolute;
        font-size: 0.12rem;
        font-family: DINAlternate-Bold, DINAlternate, sans-serif;
        font-weight: bold;
        color: #d33535;
        top: 0.05rem;
        right: -0.1rem;
        transform: scale(0.7);

        .tab-rotate-font {
          opacity: 0.5;
          transform: rotate(31deg);
        }
      }

      .tab-left-word {
        width: 0.87rem;
        height: 0.14rem;
        border-radius: 0.08rem 0 0.08rem 0;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
        color: #fff;
        font-family: PingFang SC;
        font-size: 0.1rem;
        font-weight: 500;
        line-height: 0.14rem;
        text-align: center;
      }
    }

    .tab_no_bg_white {
      background-image: none;
      border: none;
      background: #fff;
    }

    .tab-right {
      width: 1.64rem;
      height: 0.6rem;
      background: #f7f9fa;
      border-radius: 0.08rem;
      border: 0.01rem solid #f0f3f5;
      padding: 0.06rem 0 0 0.12rem;

      .tab-right-title {
        font-size: 0.12rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #242729;

        .small-font {
          font-size: 0.12rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #242729;
        }

        .big-font {
          font-size: 0.24rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #242729;
        }
      }

      .tab-right-price {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #879099;
      }
    }

    .tab-right-gary {
      width: 1.64rem;
      height: 0.6rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/18536/loFx2zzpgy.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      border-radius: 0.08rem;
      background-repeat: no-repeat;
      border: 0.01rem solid transparent;
      padding: 0.06rem 0 0 0.12rem;

      .tab-right-title {
        font-size: 0.12rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #fa2a00;

        .small-font {
          font-size: 0.12rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #fa2a00;
        }

        .big-font {
          font-size: 0.24rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #fa2a00;
        }
      }

      .tab-right-price {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #879099;
      }
    }
  }
}
</style>
